module.exports = __webpack_public_path__ + "img/csr_swiper_01_03.8a47a639.jpg";